/* eslint-disable */
export default {
  rateExceeded: '已超出请求限制。应用将在 {ttl} 秒后恢复。',
} as const;

// @key: @#@"rateExceeded"@#@ @source: @#@"Request limit exceeded. App will resume in {ttl} seconds."@#@
